module.exports = __webpack_public_path__ + "static/img/R&ED_logo_EN_FR.918e63f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/R&ED_logo_EN_FR.jpg
// module id = pXiA
// module chunks = 0